export default __webpack_public_path__ + "static/media/chocho_xl.e621b28a.jpg";